/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { AbstractControl } from "@angular/forms";
import { TimePeriodRange } from "../../models/ui/time-period-range.model";
import moment from "moment";

/**
 * Validator function to validate a time period range.
 *
 * @param required - Specifies which part of the time period is required.
 *                   Can be "start", "end", or "both". Default is "both".
 * @returns A validation function that takes an AbstractControl and returns
 *          an object with a 'required' key set to true if validation fails,
 *          or null if validation passes.
 */
export function timePeriodValidator(required: "start" | "end" | "both" = "both") {
	return (control: AbstractControl): { [key: string]: boolean } | null => {
		const value = control.value as TimePeriodRange;

		switch (required) {
			case "start":
				if (!value?.start) return { timePeriodRequired: true };

				break;
			case "end":
				if (!value?.end) return { timePeriodRequired: true };

				break;
			case "both":
				if (!value?.start || !value?.end || moment(value?.start).isAfter(value?.end))
					return { timePeriodRequired: true };

				break;
		}

		return null;
	};
}
